export default {
  VerifyModal: {
    title: "تأكيد الحساب",
    send: "إرسال للتحقق",
    step1: {
      reason:
        "تم إنشاء الخدمة خصيصًا للمتخصصين الطبيين، لذلك فإن بعض الميزات متاحة فقط للمستخدمين المؤكدين. هذا يتيح:",
      reasons: {
        1: "استبعاد وصول المرضى والأشخاص غير المخولين",
        2: "ضمان مجتمع مهني لتبادل المعرفة والخبرات",
        3: "الامتثال لأخلاقيات الطب ومعايير التعامل مع البيانات",
      },
      end: "نحن نقدر أمانك وخصوصيتك. يتم استخدام جميع المعلومات فقط للتحقق من حالتك ويتم حذفها بعد إتمام العملية.",
      status: "الحالة",
      statuses: {
        doctor: "طبيب",
        student: "طالب",
        ordinator: "مقيم",
      },
    },
    step2: {
      agenda: "جميع البيانات المقدمة محمية وتُستخدم فقط للتحقق من حالتك.",
      chooseVerifyWay: "اختر طريقة التحقق",
      ways: {
        1: "شهادة، دبلوم أو بطاقة اعتماد",
        2: "رابط إلى صفحتك المؤكدة على منصة طبية (Prodoktorov، DocDoc وغيرها)",
        3: "رابط إلى صفحتك على موقع العيادة",
        4: "تحميل دبلوم التعليم الطبي",
        5: "تحميل بطاقة الطالب من الجامعة الطبية",
      },
      selectFile: "اختر ملف",
      sendToCheck: "إرسال للتحقق",
      pasteLink: "الصق الرابط",
      notAllowedFile: "يُسمح فقط بملفات PDF والصور.",
      noMoreFiles: "الحد الأقصى للملفات - ",
    },
    step3: {
      title: "تم إرسال المستند للتحقق",
      text1_1:
        "سنقوم بالتحقق من بياناتك، ثم ستتلقى إشعارًا على البريد الإلكتروني ",
      text1_2: "",
      text2: "التحقق يستغرق يوم عمل واحد.",
    },
  },
};
